import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'signup-signup_real_time_owf_application_accepted_view-action_category_impression';

/**
 * View event for Real Time OwF Application Acceptance
 */
export function trackSignupSignupRealTimeOwfApplicationAcceptedViewActionCategoryImpression(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
